<template>
    <div>
        <div v-if="!isInProgress">
            <div class="member-panel__text">
                <p class="member-panel__headline">{{ dictionary.memberResetPasswordHeadline }}</p>
                <p>{{ dictionary.memberResetPasswordInitText }}</p>
            </div>
            <div class="formgrid grid">
                <div class="field col-12">
                    <label for="username">Email *</label>
                    <InputText id="username" type="username" v-model="v$.model.username.$model"
                        :class="{ 'p-invalid': v$.model.username.$invalid }" />
                </div>
                <div class="field col-12">
                    <Button class="p-button-primary" @click="initReset">Nulstil</Button>
                </div>
            </div>
        </div>
        <div v-if="isInProgress">
            <div class="member-panel__text">
                <p class="member-panel__headline">{{ dictionary.memberResetPasswordHeadline }}</p>
                <p>{{ dictionary.memberResetPasswordProgressText }} </p>
            </div>
            <div class="formgrid grid">
                <div class="field col-12">
                    <label for="email">Adgangskode *</label>
                    <Password v-model="v$.model.password.$model" :class="{ 'p-invalid': v$.model.password.$invalid }" />
                </div>
                <div class="field col-12">
                    <label for="email">Gentag adgangskode *</label>
                    <Password v-model="v$.model.newPassword.$model"
                        :class="{ 'p-invalid': v$.model.newPassword.$invalid }" />
                </div>
                <div class="field col-12">
                    <Button class="p-button-primary" @click="doReset">Gem</Button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Toast from 'primevue/toast';
import Password from 'primevue/password';
import VueHelpers from './../vueHelpers';

import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, sameAs } from '@vuelidate/validators'

export default {
    name: "resetPasswordMemberForm",
    props: ["dictionary", "isUserLoggedIn"],
    components: {
        Button,
        InputText,
        Toast,
        Password
    },
    data() {
        return {
            model: {
                username: null,
                password: null,
                newPassword: null,
                token: null,
                userId: null,
            },
            isInProgress: false,
        };
    },
    setup() {
        return { v$: useVuelidate() }
    },

    created() {
        const vm = this;

        if ('URLSearchParams' in window) {
            var searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has("pwreset") && searchParams.has("id") && searchParams.has("tkn")) {
                if (searchParams.get("pwreset").toLowerCase() == "true") {
                    vm.model.token = window.location.search.substring(window.location.search.indexOf("tkn=") + 4); //Need to get it like this, because UrlSearchParams encodes is wrong
                    vm.model.userId = searchParams.get("id");
                    vm.isInProgress = true;
                    vm.$emit('initPasswordReset');
                }
            }
        }
    },
    validations() {
        return {
            model: {
                username: { required, email },
                password: {
                    required,
                    minLengthValue: minLength(10),
                },
                newPassword: {
                    required,
                    minLengthValue: minLength(10),
                    sameAsPassword: sameAs(this.model.password),
                }
            }

        }
    },
    methods: {
        initReset() {
            const vm = this;
            if (!vm.v$.model.username.$invalid) {
                vm.$emit("loading", true);

                fetch('/umbraco/api/memberapi/InitPasswordReset', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify({ username: vm.model.username }),
                }).then(data => {
                    vm.$emit("loading", false);
                    vm.$toast.add({ severity: 'success', summary: vm.dictionary.memberResetPasswordInitNotificationTitle, detail: vm.dictionary.memberResetPasswordInitNotificationText, life: 10000 });
                    vm.$emit("passwordResetInitialised");
                }).catch(error => {
                    vm.$emit("loading", false);
                    vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });

                    console.log(error);
                })
            }
        },
        doReset() {
            const vm = this;

            if (vm.isInProgress && !vm.v$.model.newPassword.$invalid) {
                vm.$emit("loading", true);
                fetch('/umbraco/api/memberapi/ResetPassword', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify({ memberId: vm.model.userId, token: vm.model.token, password: vm.model.newPassword }),
                }).then(data => {
                    if (data.status == 200) {
                        vm.$emit("loading", false);
                        vm.$toast.add({ severity: 'success', summary:vm.dictionary.memberResetPasswordDoneNotificationTitle, detail: vm.dictionary.memberResetPasswordDoneNotificationText, life: 10000 });
                        vm.$emit("passwordResetDone");
                    }
                }).catch(error => {
                    vm.$emit("loading", false);
                    vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });
                    console.log(error);
                })
            }
        }
    }
};
</script>
